import { FunctionComponent } from "react";
import { AplError } from "../../../types/aplError";
import { translateSqlMessage } from "../../../translations/gridTranslationHelper";
import { Culture } from "../../../types/culture";

interface ModalDefectsErrorProps {
    culture: Culture;
    aplError: AplError | null;
}
const ModalDefectsError: FunctionComponent<ModalDefectsErrorProps> = ({ aplError, culture }) => {
    return aplError?.aplErrorCode ? (
        <div className="alert alert-danger" role="alert">
            {translateSqlMessage(aplError.aplErrorCode, aplError.detail, culture)}
        </div>
    ) : aplError?.detail ? (
        <div className="alert alert-danger" role="alert">
            {aplError.detail}
        </div>
    ) : null;
};

export default ModalDefectsError;
